import { Navigate, Outlet } from "react-router-dom";
import { getAuthAdminAccess } from "../helper";

function PublicRoute() {
  let isAuth = getAuthAdminAccess();
  return !isAuth ? <Outlet /> : <Navigate to={{ pathname: "/dashboard" }} />;
}

export default PublicRoute;
